import React, {createContext, ReactNode, useContext, useEffect, useState} from "react";
import VenueDefinition from "./gamestuff/VenueDefinition";
import MainVenue from "./gamestuff/venues/main/MainVenue";
import PartyVenue from "./gamestuff/venues/party/PartyVenue";
import {EventIntf} from "./ServerTypes";
import ConferenceGameConnection from "./ConferenceGameConnection";
import {AppContext} from "../AppContext";
import {StateContext} from "./twilio/state";

export interface IGameContext {
    event:EventIntf
    venue:VenueDefinition
    gameConnection: ConferenceGameConnection
    currentRoom:string
    setCurrentRoom:(currentRoom:string)=>void
    myRole:"Attendee" | "Admin" | "Speaker" | "Sponsor"
    isHost:boolean
    connectWebsocket:(onEnabledChange: (enabled: boolean) => void) => void
    setTwilioToken:(token:string) => void
}

export const GameContext = createContext<IGameContext>(null!);

interface  GameContextProps {
    children: ReactNode;
    options?: GameOptions;
}

export interface GameOptions{
    event:EventIntf
}

export function GameProvider({ options, children }: GameContextProps){
    let event = options?.event!;
    const venueString = event.venue as string

    const [venue] = useState(makeEvent(venueString, event))
    const [gameConnection] = useState(new ConferenceGameConnection())
    const [currentRoom, setCurrentRoom] = useState("")
    const [myRole, setRole] = useState<"Attendee" | "Admin" | "Speaker" | "Sponsor">("Attendee")
    const [isHost, setHost] = useState<boolean>(false)
    const context = useContext(AppContext)
    const stateContext = useContext(StateContext)

    const connectWebsocket = (onEnabledChange: (enabled: boolean) => void) => {
        const user = context.currentUser as any
        if(user != null) {
            gameConnection.connect(
                event,
                user.id as number,
                onEnabledChange,
                () => venue.callRefresh()
            )
        }
    }

    const setTwilioToken = (token:string) => stateContext.setToken(token)

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_CALL}/event-user-info/${event.id}`, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(data => {
                setRole(data.my_role)
                setHost(data.is_host)
            })
    }, [event])

    let contextValue = {
        event,
        venue,
        gameConnection,
        currentRoom,
        setCurrentRoom,
        myRole,
        isHost,
        connectWebsocket,
        setTwilioToken
    } as IGameContext

    return <GameContext.Provider value={ contextValue }>
        {children}
    </GameContext.Provider>
}

function makeEvent(venueString:string, event:EventIntf):VenueDefinition{
    if (!venueString || venueString === "MainVenue") {
        return new MainVenue(event)
    } else if (venueString === "PartyVenue") {
        return new PartyVenue(event)
    } else {
        return new PartyVenue(event)
    }
}

/*

export const GameContext = React.createContext({

})*/
